module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"it's-your-fault\"-in-pomona-california-3e47896ea4868bea8e20fb0ed0d3ddc4.png";